import React, {useState, useContext, useRef, useEffect} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime, IonFooter } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal } from './../../zInternal_Features/merchant/components/Modal_ViewInvoice';
import { Onboarding_Details } from '../../zInternal_Features/merchant/components/ViewOnboarding_DetailData';

import '../../../css/qavaApp.css';
import './../../zInternal_Features/merchant/css/zInternal_css.css';


export function Applicant_OfferLetterModal (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [applicant_merchantID, setAppliant_merchantID] = useState(null);
    let [applicant_requisitionID, setAppliant_requisitionID] = useState(null);
    let [applicant_applicationID, setAppliant_applicationID] = useState(null);

    let [viewOfferDetails, setViewOfferDetails] = useState([]);

    let [applicantFirstName, setApplicantFirstName] = useState(null);
    let [applicantLastName, setApplicantLastName] = useState(null);
    let [requisitionName, setRequisitionName] = useState(null);
    let [applicant_phoneNumber, setApplicant_phoneNumber] = useState(null);
    let [offer_status_initial, setOffer_status_initial] = useState(null);
    let [offer_status, setOffer_status] = useState(null);
    let [offer_date, setOffer_date] = useState(null);
    let [offer_amount, setOffer_amount] = useState(null);

    let [offer_document, setOffer_document] = useState(null);

    let [viewOfferDocumentModal, setViewOfferDocumentModal] = useState(false);
    let [openOnboardingModal, setOpenOnboardingModal] = useState(false);



    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);

    

    function getData_offerDocument () {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: "74503_applicant_retrieve_offer_document",
                user: props.data.applicant_merchant_accountID,
                xJobRequisitionID: props.data.applicant_requisitionID,
                xJobApplicationID: props.data.applicant_applicationID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'ghanaverified/', requestOptions)
        .then(res => res.text())
        .then(res => {

            //alert(res);

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                if(cols[10] == 'offer_approved')
                {
                    setOpenOnboardingModal(true);
                }

                setApplicantFirstName(cols[4]);
                setApplicantLastName(cols[6]);
                setRequisitionName(cols[2]);

                setApplicant_phoneNumber(cols[7]);
                setOffer_status_initial(cols[10])
                setOffer_status(cols[10]);
                setOffer_date(cols[11]);
                setOffer_amount(cols[12]);
                setOffer_document(cols[13]);

                setViewOfferDetails((prevViewRequisitionList) => {
                    return prevViewRequisitionList.concat({
                        requisitionID: cols[0], 
                        application_id: cols[1], 
                        requisitionName: cols[2], 
                        company_role: cols[3], 
                        applicant_first_name: cols[4], 
                        applicant_middle_name: cols[5], 
                        applicant_last_name: cols[6], 
                        applicant_phone_number: cols[7], 
                        applicant_email_address: cols[8], 
                        date_recieved: cols[9], 
                        offer_status: cols[10],
                        offer_date: cols[11],
                        offer_amount: cols[12],
                        offer_document: cols[13],
    
                    })
                });
            } 
        })

    };

    function updateOfferStatus()
    {

        
        let formData = new FormData();
        formData.append('Tracker', '74503_applicant_offer_status_decision');
        formData.append('user', props.data.applicant_merchant_accountID);
        formData.append('xJobRequisitionID', props.data.applicant_requisitionID);
        formData.append('xJobApplicationID', props.data.applicant_applicationID);
        //formData.append('xApplicantMobileNumber', applicant_phoneNumber);
        formData.append('xOffer_status', offer_status);
        // formData.append('xOffer_date', offer_date);
        // formData.append('xOffer_amount', offer_amount);
        // formData.append('xOffer_document', offer_document);
        formData.append('sessionID', sessionID);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        

        fetch(baseURL+'ghanaverified/', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
            
            props.closeModal(false);

        })
        .catch(error => {
            console.error(error);
        })
    }

    function viewInvoiceModalHandler(event) {


        setOffer_document(event[1]);
        setViewOfferDocumentModal(event[0]);

    }



    function closeModalHandler() {

        props.closeModal(false);
    }

    useEffect(() => {

        getData_offerDocument();

    }, [])  
    

    // alert("In Offer Letter");
    // alert(offer_status);
    // alert(openOnboardingModal);

    return (
        <React.Fragment>
        {(props.openModal == true && offer_status != 'offer_approved') ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonContent className='bookedDetails_gridContent_multiple'>
        <IonSlides pager='true' className='custom-pagination' options={{ speed: 100 }}>
        <IonSlide>
            {viewOfferDetails.map((detailData) =>   {
            return (
                <IonGrid>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Offer Information</IonLabel>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonText>Offer Date</IonText>
                            </IonCol>
                            <IonCol>
                                <IonText>{offer_date}</IonText>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonText>Offer Ammount / Month</IonText>
                            </IonCol>
                            <IonCol>
                                <IonText>{offer_amount}</IonText>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonText>Offer Document</IonText>
                            </IonCol>
                            <IonCol>
                                <IonButton className='gridResultColumnButton' onClick={() => viewInvoiceModalHandler([true, offer_document])}> View </IonButton>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonText>Offer Status</IonText>
                            </IonCol>
                            <IonCol>
                                <IonText>{offer_status}</IonText>
                            </IonCol>
                            {offer_status != "customer_accepted"  && <IonCol>
                                <IonButton onClick={() => setRow_4(true)}>Update</IonButton>
                            </IonCol>}
                            {(row_4 == true && offer_status != "customer_accpeted") && <IonCol>
                                <select name="offer_status" id='offer_status' default={offer_status} onChange={(e) => setOffer_status(e.target.value)}>
                                    <option value='none'>Select</option>
                                    <option value='customer_accepted'>Accept Offer</option>
                                    <option value='customer_declined'>Decline Offer</option>
                                </select>
                            </IonCol>}
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                {offer_status_initial == "job_offered"  && <IonButton onClick={() => updateOfferStatus()}>CONFIRM</IonButton>}
                                {offer_status_initial == "customer_accepted"  && <IonText >PENDING REVIEW</IonText>}
                            </IonCol>
                        </IonRow>
                    </IonGrid>)}
            )}
            </IonSlide>
        </IonSlides>
        </IonContent>

        <IonFooter className='appFooter_internal'>
            <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>
        </IonFooter>
        {viewOfferDocumentModal == true && <ViewInvoiceModal openModal={ viewOfferDocumentModal } closeModal={() => setViewOfferDocumentModal(false)} data={{
                                        fileLocation: offer_document, 
                                        applicationID: props.data.applicant_applicationID, 
                                        }}></ViewInvoiceModal>}

        </IonModal>) : null}


        {offer_status == 'offer_approved' &&  <Onboarding_Details openModal= { openOnboardingModal } closeModal={() => setOpenOnboardingModal(false)} data={{
                        applicationID:  props.data.applicant_applicationID, 
                        applicant_first_name: applicantFirstName, 
                        applicant_last_name: applicantLastName, 
                        requisitionID: props.data.applicant_requisitionID, 
                        requisitionName: requisitionName,
                        applicant_merchant_accountID: props.data.applicant_merchant_accountID,
                        status: 'user_applicant_onboarding',

                                            }}></Onboarding_Details>}
    </React.Fragment>
    )
}